var foiSearch = function () {

	let foiForm = $('#foiForm'); 
	let foiSearchInput = $('#foi-search');
	let searchFieldClearLink = $('a#searchFieldClearLink');
	let searchResultsClearLink = $('button#searchResultsClearLink');
	let searchSubmitBtn = $('button#searchSubmitBtn');

	let filterMonth = $('select#month-filter');
	let filterYear = $('select#year-filter');
	let searchFilterClearLink = $('button#filterResultsClearLink');
	let filterSubmitBtn = $('button#filterSubmit');
	let foiPageError = $('div#foiPageError');
	let foiPageErrorContent = $('div#foiPageErrorContent');

	$(document).ready(function () {

		clearSearchFieldIcon();
		if (foiPageErrorContent.length) {
			let foiPageErrorHtml = foiPageErrorContent.html();
			foiPageError.html(foiPageErrorHtml);
			foiPageError.removeClass('x');

			setTimeout(function () {
				foiPageError.html(foiPageErrorHtml);
			}, 6000); // end timeout
		};

		let url = window.location.href;

		if (url.includes('searchSubmit')) {
			searchSubmitBtn.focus();
		}
		else if (url.includes('filterSubmit')) {
			filterSubmitBtn.focus();
		}
		else if (url.includes('searchResultsClearLink') | url.includes('filterResultsClearLink')) {
			foiSearchInput.focus();
		}

		filterYear.on('change', checkFutureDate);
		filterMonth.on('change', checkFutureDate);

		function checkFutureDate() {
			const now = new Date;
			let filterYearVal = new Date(filterYear.val());
			let filterMonthVal = new Date(filterMonth.val());

			if (filterYearVal.getFullYear() == now.getFullYear() && filterMonthVal.getMonth() > now.getMonth()) {
				$('#futureDateError').show();
				filterSubmitBtn.attr('disabled', 'disabled');

			}
			else {
				$('#futureDateError').hide();
				filterSubmitBtn.removeAttr('disabled');
			}

		};


	});

	foiSearchInput.on('input', clearSearchFieldIcon);

	function clearSearchFieldIcon() {
		if (foiSearchInput.length > 0 && foiSearchInput.val().length > 0) {
			searchFieldClearLink.removeClass('x');
		} else {
			searchFieldClearLink.addClass('x');
		}
	}

	searchFieldClearLink.on('click', searchFieldClearLinkFn);
	searchFieldClearLink.on('keydown', function (e) {
		if (e.which == 13) //enter pressed                
		{
			e.preventDefault();
			searchFieldClearLinkFn();
		}
	});

	function searchFieldClearLinkFn() {
		foiSearchInput.val("");
		searchFieldClearLink.addClass('x');
		setTimeout(function () {
			foiSearchInput.focus();
		}, 150); // end timeout
	}

	searchResultsClearLink.on('click', searchResultsClearLinkFn);
	searchResultsClearLink.on('keydown', function (e) {
		if (e.which == 13) //enter pressed                
		{
			searchResultsClearLinkFn();
		}
	});

	function searchResultsClearLinkFn() {
		foiSearchInput.val("").removeAttr("required").rules("remove");
		filterMonth.removeAttr("required").rules("remove");
		filterYear.removeAttr("required").rules("remove");
			foiForm.trigger("submit");
	}

	searchSubmitBtn.on('click', function () {
		foiSearchInput.rules("add", "required");
		filterMonth.removeAttr("required").rules("remove");
		filterYear.removeAttr("required").rules("remove");
	});

	searchFilterClearLink.on('click', searchFilterClearLinkFn);
	searchFilterClearLink.on('keydown', function (e) {
		if (e.which == 13) //enter pressed                
		{
			searchFilterClearLinkFn();
		}
	});

	function searchFilterClearLinkFn() {
		filterMonth.val("").removeAttr("required").rules("remove");
		filterYear.val("").removeAttr("required").rules("remove");
		foiSearchInput.removeAttr("required").rules("remove");
		foiForm.trigger("submit");
	}

	filterSubmitBtn.on('click', function () {
		filterYear.rules("add", "required");
		filterMonth.rules("add", "required");
		foiSearchInput.removeAttr("required").rules("remove");
		filterMonth.attr("required", "true").rules("remove");
	});

};



